import '../styles/index.scss';

import {tns} from 'tiny-slider/src/tiny-slider';
import {CountUp} from 'countup.js';

import './base';

if (document.querySelectorAll('.header-slider').length) {
  const portfolio = tns({
    container: '.header-slider',
    items: 1,
    slideBy: 'page',
    autoplay: true,
    autoplayHoverPause: true,
    autoplayButtonOutput: false,
    autoHeight: false,
    nav: false,
    gutter: 0,
    nextButton: '#header-slide-arrow--next',
    prevButton: '#header-slide-arrow--prev',
    responsive: {
      992: {
        gutter: 50,
        items: 1
      }
    }
  });
}

window.addEventListener('scroll', () => {
  const options = {
    separator: '&nbsp;',
    duration: '4',
    useEasing: true,
    useGrouping: true
  };

  const numbers = document.querySelectorAll('[data-numbers]');

  numbers.forEach((numberElement) => {

    const numberPosition = numberElement.getBoundingClientRect().top + window.scrollY - window.innerHeight;

    if ((!numberElement.hasAttribute('data-numbers-launched')) && window.scrollY > numberPosition) {
      const countUp = new CountUp(numberElement, numberElement.getAttribute('data-numbers-to'), options);

      if (!countUp.error) {
        countUp.start();

        numberElement.setAttribute('data-numbers-launched', '');
      } else {
        console.error(countUp.error);
      }
    }
  });
});


